export const text = {
    // TODO: localize
    alignLeft: `Align Left`,
    alignCenter: `Align Center`,
    alignRight: `Align Right`,
    wrapLeft: `Wrap Left`,
    wrapRight: `Wrap Right`,
    addCaption: `Add Caption`,
    remove: `Remove`,
    fullscreen: `Full Screen`,
};
